// @ts-ignore
import mergeImages from 'merge-images';
import Compress from "react-image-file-resizer";
import {Button, notification} from "antd";
import Texts from "../defaults/Text";
const getBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = error => reject(error);
    });
function getSizes(argArr: any[], callback: (arrSizes: any[]) => any) {
    let arrSizes: any[] = [];
    let index = -1;
    for (const singleItem of argArr) {
        index += 1;
        let img = new Image();
        // @ts-ignore
        img.src = window.URL.createObjectURL(singleItem);
        img.onload = () => {
            arrSizes.push([img.width, img.height]);
            if (index + 1 === argArr.length) {
                setTimeout(() => callback(arrSizes), 10);
            }
        };
    }
}
function getMergeImage(argArr: any[], callback: (value: any) => any) {
        if(argArr.length){
            getBase64(argArr[argArr.length-1]).then(base64=>{


                if(argArr[argArr.length-1].size/1000000){

                    callback('')
                }else {
                    callback(base64)
                }

                console.log(base64)
                callback(base64)
            })
        }else {
            callback('')
        }


/*    const p = new Promise((res, rej) => {
        let images: Array<File>=[] ;
        for (let i=0;i<argArr.length;i++){

            Compress.imageFileResizer(
                argArr[i], // the file from input
                400, // width
                1000, // height
                "PNG", // compress format WEBP, JPEG, PNG
                80, // quality
                0, // rotation
                (base64: any) => {
                    console.log('item')
                    console.log(base64)

                    fetch(base64)
                        .then(res => res.blob())
                        .then(blob => {
                            const file = new File([blob], "File name",{ type: "image/png" })
                            images.push(file)
                            if(images.length===argArr.length){
                                res(images);
                            }
                        })


                },
                "base64" // blob or base64 default base64
            );

        }
    });
    p.then((compressedImages:any)=>{
        getSizes(compressedImages, (arrSizes) => {
            const sources: any = [];
            let maxHeight = 0;
            let maxWidth = 0;

            let index = -1;
            for (const singleItem of compressedImages) {
                index += 1;
                let thisWidth = arrSizes[index][0];
                let thisHeight = arrSizes[index][1];

                // @ts-ignore
                sources.push({src: URL.createObjectURL(singleItem), x: '0', y: maxHeight});
                maxHeight += thisHeight;
                if (thisWidth > maxWidth) {
                    maxWidth = thisWidth;
                }
            }
            mergeImages(sources, {width:maxWidth,height:maxHeight}).then((b64:string) =>{
                console.log(b64)
                callback(b64)
              /!*  fetch(b64)
                    .then(function(res){return res.arrayBuffer();})
                    .then(function(buf){
                        callback(new File([buf], 'image.png',{type:'image/png'}))

                    });*!/

            });
        });

    })*/

    /*    let Images=[];
        for (let i=0;i<argArr.length;i++){
            Compress.imageFileResizer(
                argArr[i], // the file from input
                1000, // width
                1000, // height
                "JPEG", // compress format WEBP, JPEG, PNG
                80, // quality
                0, // rotation
                (base64: any) => {
                    fetch(base64)
                        .then(res => res.blob())
                        .then(blob => {
                            const file = new File([blob], "File name",{ type: "image/png" })
                            Images.push(file)
                        })


                },
                "base64" // blob or base64 default base64
            );

        }*/


}
/* function getMergeImage(argArr: any[], callback: (value: string) => any) {
    const p = new Promise((res, rej) => {
        let images: Array<File>=[] ;
        for (let i=0;i<argArr.length;i++){

            Compress.imageFileResizer(
                argArr[i], // the file from input
                700, // width
                2000, // height
                "PNG", // compress format WEBP, JPEG, PNG
                85, // quality
                0, // rotation
                (base64: any) => {
                    console.log('item')
                    console.log(base64)

                    fetch(base64)
                        .then(res => res.blob())
                        .then(blob => {
                            const file = new File([blob], "File name",{ type: "image/png" })
                            images.push(file)
                            if(images.length===argArr.length){
                                res(images);
                            }
                        })


                },
                "base64" // blob or base64 default base64
            );

        }
    });
    p.then((compressedImages:any)=>{
        getSizes(compressedImages, (arrSizes) => {
            const sources: any = [];
            let maxHeight = 0;
            let maxWidth = 0;

            let index = -1;
            for (const singleItem of compressedImages) {
                index += 1;
                let thisWidth = arrSizes[index][0];
                let thisHeight = arrSizes[index][1];

                // @ts-ignore
                sources.push({src: URL.createObjectURL(singleItem), x: '0', y: maxHeight});
                maxHeight += thisHeight;
                if (thisWidth > maxWidth) {
                    maxWidth = thisWidth;
                }
            }
            mergeImages(sources, {width:maxWidth,height:maxHeight}).then((b64:string) =>{
                console.log('final')
                console.log(b64)
                callback(b64)
            });
        });

    })

    /!*    let Images=[];
        for (let i=0;i<argArr.length;i++){
            Compress.imageFileResizer(
                argArr[i], // the file from input
                1000, // width
                1000, // height
                "JPEG", // compress format WEBP, JPEG, PNG
                80, // quality
                0, // rotation
                (base64: any) => {
                    fetch(base64)
                        .then(res => res.blob())
                        .then(blob => {
                            const file = new File([blob], "File name",{ type: "image/png" })
                            Images.push(file)
                        })


                },
                "base64" // blob or base64 default base64
            );

        }*!/


}*/
export {getBase64,getMergeImage}